<template>
  <div class="sc-stages-values">
    <row
      :gutter="48"
      class="sc-stages-values__filter"
      v-if="contract[`${type}_scenario`] === 3"
    >
      <i-col span="14">
        <div class="ms-help label">Включенные в распределение этапы</div>
        <i-select
          size="default"
          v-model="contract[`${type}_stages`]"
          :max-tag-count="1"
          multiple
          @on-change="filterChangeHandler"
        >
          <i-option v-for="(item, i) in contract.roadmaps" :key="i" :value="i">
            {{ item.name }}
          </i-option>
        </i-select>
      </i-col>
    </row>
    <row :gutter="16" class="sc-stages-values__table">
      <i-col span="24">
        <div class="ms-help label">Распределение суммы по этапам</div>
        <i-table
          no-data-text="Этапы отсутствуют"
          border
          :data="filteredRoadmap"
          :columns="columns"
          :disabled-hover="true"
          size="small"
          show-summary
          :summary-method="handleSummary"
        >
          <template slot-scope="{ row, index }" :slot="type">
            <input-number
              @on-change="setData(index, [`${type}_value`], $event)"
              v-model="row[`${type}_value`]"
              :min="0"
              :max="getMax(index)"
              :formatter="costsFormatter"
              :parser="costsParser"
            />
          </template>
        </i-table>
      </i-col>
    </row>
  </div>
</template>

<script>
import { costsFormatter, costsParser, getSummaryRow, round } from '@/utils'

const getColumns = (type, { with_vat }) => [
  { title: '№', key: 'number', width: 64, align: 'center' },
  { title: 'Наименование', key: 'name' },
  { title: with_vat ? 'Сумма с НДС' : 'Сумма без НДС', slot: type, width: 200 }
]

export default {
  props: ['contract', 'type'],
  data () {
    return {
      columns: getColumns(this.type, this.contract)
    }
  },
  computed: {
    filteredRoadmap () {
      const { roadmaps } = this.contract
      const scenario = this.contract[`${this.type}_scenario`]

      if (scenario !== 3) return roadmaps

      return roadmaps.filter((r, i) =>
        this.contract[`${this.type}_stages`].includes(i)
      )
    }
  },
  methods: {
    getMax (index) {
      const { roadmaps } = this.contract
      const otherSum = roadmaps.reduce((prev, s, i) => {
        if (i !== index) return prev + s[`${this.type}_value`]
        return prev
      }, 0)
      const otherType = this.type === 'prepaid' ? 'retention' : 'prepaid'
      const otherValue = roadmaps[index][`${otherType}_value`]
      const { costs } = roadmaps[index]
      const max = this.contract[`${this.type}_amount`] - otherSum
      const value = max < costs - otherValue ? max : costs - otherValue

      return Number(value.toFixed(2))
    },
    setData (index, name, value) {
      this.$set(this.contract.roadmaps[index], name, value)
    },
    filterChangeHandler (selected) {
      this.contract.roadmaps.forEach((r, i) => {
        if (!selected.includes(i)) this.$set(r, `${this.type}_value`, 0)
      })

      const roadmaps = this.contract.roadmaps.filter((_, i) =>
        selected.includes(i)
      )
      const costs = roadmaps.reduce((prev, el) => prev + el.costs, 0)

      this.contract[`${this.type}_amount`] = round(
        (costs * this.contract[`${this.type}_percentage`]) / 100,
        2
      )
    },
    handleSummary (payload) {
      return getSummaryRow(payload, [2], `${this.type}_value`)
    },
    costsFormatter,
    costsParser
  },
  created () {
    if (!this.contract[`${this.type}_stages`]) {
      this.$set(this.contract, `${this.type}_stages`, [])
    }
  }
}
</script>

<style lang="less">
.sc-stages-values {
  &__filter {
    margin-bottom: 8px;
  }

  &__table {
    tbody {
      th {
        .ivu-table-cell {
          width: 100%;
          text-align: center;
        }
      }
      td {
        padding: 0;
        height: 28px;
      }

      .ivu-table-cell {
        padding: 0 8px;

        .ivu-input-number {
          width: 100%;
          border: none;

          &:focus,
          &-focused {
            box-shadow: none !important;
          }

          &-handler-wrap {
            display: none;
          }
        }
      }
    }
  }
}
</style>
